import {Controller, type FieldValues} from 'react-hook-form'

import {ControlledFormField} from '../../types'
import {Select, SelectProps} from '../inputs'

type SelectFieldProps<
  TOptionValue extends string | number,
  TField extends FieldValues
> = ControlledFormField<TField> &
  Omit<SelectProps<TOptionValue>, 'onChange'> & {
    onChange?: (value: TOptionValue | undefined) => void
  }

export const SelectField = <TOptionValue extends string | number, TField extends FieldValues>({
  control,
  name,
  options,
  label,
  disabled,
  readOnly,
  optional,
  helperText,
  onChange,
  ...otherSelectProps
}: SelectFieldProps<TOptionValue, TField>) => (
  <Controller
    name={name}
    control={control}
    disabled={disabled || readOnly}
    render={({field, fieldState}) => (
      <Select
        data-test-id={name ? `select-field-${name}` : undefined}
        {...otherSelectProps}
        {...field}
        onChange={(value) => {
          field.onChange(value)
          onChange?.(value)
        }}
        label={label}
        options={options}
        error={fieldState.invalid}
        helperText={fieldState.error?.message || helperText}
        readOnly={readOnly}
        disabled={disabled}
        optional={optional}
      />
    )}
  />
)
